import generalServerAdmin from './generalServerAdmin';
import generalOrgAdmin from './generalOrgAdmin';
import generalUserAdmin from './generalUserAdmin';
import generalGroupAdmin from './generalGroupAdmin';
import generalRootAdmin from './generalRootAdmin';
import generalCommon from './generalCommon';
import settings from './settings';
import reports from './reports';

// ==============================|| MENU ITEMS ||============================== //

export const userAdminMenuItems = {
    items: [generalUserAdmin, reports]
};

export const groupAdminMenuItems = {
    items: [generalGroupAdmin, reports]
};

export const orgAdminMenuItems = {
    items: [generalOrgAdmin, settings, reports]
};

export const serverAdminMenuItems = {
    items: [generalServerAdmin, settings, reports]
};

export const rootAdminMenuItems = {
    items: [generalRootAdmin]
};

export const commonMenuItems = {
    items: [generalCommon, reports]
};

export default { commonMenuItems, userAdminMenuItems, groupAdminMenuItems, orgAdminMenuItems, serverAdminMenuItems, rootAdminMenuItems };
